import React from 'react';
import { DeclineCommentProps } from './types';
import { Comment, Text } from './decline-comment.styles';
import { Typography } from '../typography/typography';
import { Photo } from '../photo/photo';

export const DeclineComment: React.FC<DeclineCommentProps> = ({ avatarUrl, name, message }) => {
    return (
        <Comment>
            <Photo photoUrl={avatarUrl} name={name} />
            <Text>
                <Typography size='body1_short'>{name}</Typography>
                <Typography size='body2_long' color='neutral_50'>
                    {message}
                </Typography>
            </Text>
        </Comment>
    );
};
